const prefix = 'eSupervisor'

function __session_set(key, value) {
  if (typeof value !== 'string') {
    value = JSON.stringify(value)
  }
  let k = prefix + '.' + key
  window.sessionStorage.setItem(k, value)
}

function __session_get(key) {
  let k = prefix + '.' + key
  return window.sessionStorage.getItem(k)
}


function __session_remove(key) {
  let k = prefix + '.' + key
  return window.sessionStorage.removeItem(k)
}

export function setToken(token) {
  __session_set('token', token)
}

export function getToken() {
  return __session_get('token')
}

export function removeToken() {
  __session_remove('token')
}

export function setUser(user) {
  __session_set('user', user)
}

export function getUser() {
  let userStr = __session_get('user')
  if (userStr != null) {
    return JSON.parse(userStr)
  }
}

export function saveSystemSign(systemSign) {
  __session_set('systemSign', systemSign)
}

export function getSystemSign() {
  return __session_get('systemSign')
}

export function saveLogTab(tab) {
  __session_set('logTab', tab)
}

export function getLogTab() {
  return __session_get('logTab') || 'online-user'
}



export function save(key, object) {
  __session_set(key, object)
}

export function load(key) {
  const strOrNull = __session_get(key)
  if (strOrNull !== null) {
    try {
      return JSON.parse(strOrNull)
    } catch (error) {
      // console.error(error)
      return strOrNull
    }
  }
}
